import React from 'react'
import './ElevatedCircle.scss'

export const ElevatedCircle = (props) => {
        return (<div className="elevated-circle-icon">{props.children}</div>)
}